import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import type { IssueCard } from '@tasks/contracts';

import { Avatar } from '../../components/Avatar';
import { Badge } from '../../components/Badge';
import type { TableColumn } from '../../components/Table';
import { formatDate, formatPoints } from '../../lib/format';
import { PRIORITY_COLOR_VAR } from '../../lib/types';
import { priorityLabels } from '../../i18n/enums';
import styles from './SearchPage.module.css';

/** Колонки таблицы результатов JQL-поиска (docs/06 §3.4). */
export function useSearchColumns(): readonly TableColumn<IssueCard>[] {
  return useMemo(
    () => [
      {
        id: 'key',
        header: 'Ключ',
        width: '108px',
        sortable: true,
        render: (issue) => (
          <Link to={`/projects/${issue.key.split('-')[0]}/board?issue=${issue.key}`} className={styles['keyLink']}>
            {issue.key}
          </Link>
        ),
      },
      {
        id: 'summary',
        header: 'Заголовок',
        sortable: true,
        render: (issue) => <span className="u-truncate">{issue.summary}</span>,
      },
      {
        id: 'type',
        header: 'Тип',
        width: '90px',
        sortable: true,
        render: (issue) => <Badge>{issue.type}</Badge>,
      },
      {
        id: 'priority',
        header: 'Приоритет',
        width: '124px',
        sortable: true,
        render: (issue) => (
          <span className={styles['priority']}>
            <span aria-hidden className={styles['dot']} style={{ background: PRIORITY_COLOR_VAR[issue.priority] }} />
            {priorityLabels[issue.priority]}
          </span>
        ),
      },
      {
        id: 'assignee',
        header: 'Исполнитель',
        width: '170px',
        sortable: true,
        render: (issue) => (
          <span className={styles['assignee']}>
            <Avatar user={issue.assignee} size="xs" />
            <span className="u-truncate">{issue.assignee?.displayName ?? 'Не назначен'}</span>
          </span>
        ),
      },
      {
        id: 'points',
        header: 'SP',
        width: '64px',
        align: 'end',
        sortable: true,
        render: (issue) => <span className="u-mono">{formatPoints(issue.storyPoints)}</span>,
      },
      {
        id: 'dueDate',
        header: 'Срок',
        width: '100px',
        sortable: true,
        render: (issue) => (
          <span className={issue.isOverdue ? styles['overdue'] : undefined}>{formatDate(issue.dueDate)}</span>
        ),
      },
    ],
    [],
  );
}
